import type { BenefitsValueObjectsBenefitTransactionCategoryEnum } from 'generated/resources/graphql'

export type TransactionCategory = BenefitsValueObjectsBenefitTransactionCategoryEnum

export const MEALS_CATEGORY: TransactionCategory = 'meals' as const
export const TRANSPORTATION_CATEGORY: TransactionCategory = 'transportation' as const
